import type { FileToReview } from './types';

// Re-export shared utility
export { formatTime as formatTimeRemaining } from '@utils/format-time';

/**
 * File diff statistics
 */
export interface FileDiff {
  additions: number;
  deletions: number;
}

/**
 * Calculate additions/deletions for a file based on line count changes
 */
export function getFileDiff(file: FileToReview): FileDiff {
  const oldLines = file.oldCode ? file.oldCode.split('\n').length : 0;
  const newLines = file.newCode ? file.newCode.split('\n').length : 0;
  return {
    additions: Math.max(0, newLines - oldLines),
    deletions: Math.max(0, oldLines - newLines),
  };
}

/**
 * File tree node structure for hierarchical display
 */
export interface FileTreeNode {
  name: string;
  path: string;
  isFolder: boolean;
  children: FileTreeNode[];
  file?: FileToReview;
}

/**
 * Build hierarchical tree from flat file list
 */
export function buildFileTree(files: FileToReview[]): FileTreeNode[] {
  const root: FileTreeNode[] = [];

  for (const file of files) {
    const parts = file.filename.split('/');
    let currentLevel = root;

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      const isLastPart = i === parts.length - 1;
      const currentPath = parts.slice(0, i + 1).join('/');

      let existing = currentLevel.find((node) => node.name === part);

      if (!existing) {
        existing = {
          name: part,
          path: currentPath,
          isFolder: !isLastPart,
          children: [],
          file: isLastPart ? file : undefined,
        };
        currentLevel.push(existing);
      }

      currentLevel = existing.children;
    }
  }

  // Preserve original order from the files array (no alphabetical sorting)
  return root;
}
